module.exports = __webpack_public_path__ + "54061acab2730ad22b3a0481b8817447.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/747.png
// module id = 1689
// module chunks = 2